import { isCurrentPathPresent } from "utils";

const LP_TAG_RETRIES = 10;
const LP_TAG_RETRY_DELAY = 500;

const standaloneItemsKey = "StandaloneItems: ";
const standaloneItemsRegex =
	/StandaloneItems:(.*?price:\s*\d+\.\d{2}\s*\w+,\s*)/s;
const productInfoRegex =
	/^(.*?)(?:\s*,\s*qty:\s*(\d+)\s*,\s*price:\s*([\d.]+)\s*(\w+))/;
const qtyRegex = /, qty:(\d+)/;

export const formatCartData = (cartInfo = {}) => {
	const formattedCart = {
		total: Number(cartInfo?.total?.toString().replace(/[$,]/g, "").trim()) || 0,
		products: [],
		numItems: 0,
	};
	const pushProduct = (quantity, category, name, price) => {
		if (!name && !category) return;
		const qtyMatch = name?.match(qtyRegex);
		if (qtyMatch) {
			quantity = parseInt(qtyMatch[1], 10) || quantity;
			name = name.replace(qtyRegex, "").trim();
		}
		formattedCart.products.push({
			quantity: quantity || 1,
			product: {
				category: category || " ",
				name: name,
				price: Number(price) || 0,
			},
		});
	};
	let currency = cartInfo.currency;
	try {
		if (cartInfo.navCartInformation) {
			cartInfo.products.forEach((product) => {
				const content =
					typeof product.content === "object"
						? product.content.content
						: product.content;
				pushProduct(
					product.quantity,
					product.category,
					`${product.title}${content ? ` - ${content}` : ""}`,
					0
				);
				product.items?.forEach((item) => {
					const itemContent =
						typeof item.content === "object"
							? item.content.content
							: item.content;
					pushProduct(item.quantity, item.category, itemContent, 0);
				});
			});
		} else if (Array.isArray(cartInfo.products)) {
			cartInfo.products.forEach((productInfo) => {
				pushProduct(
					productInfo.quantity,
					productInfo.product.category,
					productInfo.product.name,
					productInfo.product.price
				);
			});
		} else if (cartInfo.products?.product) {
			let standaloneItems = "";
			const productInfo = cartInfo.products.product;
			const match = productInfo.name?.match(standaloneItemsRegex);
			if (match) {
				standaloneItems = match[1]?.trim();
				productInfo.name = productInfo.name?.replace(match[0], "").trim();
				if (productInfo.name) {
					pushProduct(
						cartInfo.products?.quantity,
						productInfo.category,
						productInfo.name,
						productInfo.price
					);
				}
			} else if (productInfo.name?.includes(standaloneItemsKey)) {
				standaloneItems = productInfo.name
					.replace(standaloneItemsKey, "")
					.trim();
			} else {
				pushProduct(
					cartInfo.products?.quantity,
					productInfo.category,
					productInfo.name,
					productInfo.price
				);
			}
			if (standaloneItems) {
				const splittedItems = standaloneItems.split(";");
				splittedItems.forEach((item) => {
					const itemMatch = item.trim().match(productInfoRegex);
					if (itemMatch) {
						if (!currency) {
							currency = itemMatch[4];
						}
						pushProduct(itemMatch[2], " ", itemMatch[1]?.trim(), itemMatch[3]);
					}
				});
			}
		} else if (cartInfo.products && typeof cartInfo.products === "object" && cartInfo.products.quantity) {
			pushProduct(parseInt(cartInfo.products.quantity, 10), "-", "-", 0);
		}
		formattedCart.currency = currency;
		formattedCart.numItems = formattedCart.products.length;
		formattedCart.isOnlyForProactive = cartInfo.isOnlyForProactive || false;
	} catch (error) {
		console.error("Error processing cart information", error);
	}
	return formattedCart;
};

export const processCartInformation = (cartInfo = {}, setCartInformation) => {
	const formattedData = formatCartData(cartInfo);
	setCartInformation({ ...formattedData, type: "cart" });
};

export const sendCartToChat = (
	cartData,
	sendCartInformationPages = [],
	isSendCartToChatEnabled = false
) => {
	if (
		!isSendCartToChatEnabled ||
		isCurrentPathPresent(sendCartInformationPages)
	)
		return;
	let retries = LP_TAG_RETRIES;
	const interval = setInterval(() => {
		if (window.lpTag?.sdes?.push) {
			clearInterval(interval);
			window.lpTag.sdes.push({
				type: "cart",
				...cartData,
				isOnlyForProactive: true,
				navCartInformation: true,
			});
		} else if (--retries <= 0) {
			clearInterval(interval);
		}
	}, LP_TAG_RETRY_DELAY);
};
